import Styled from "styled-components";
import { fontSize, color, spacingDefaults } from "style/constants";

export const StyledSubTitle = Styled.h2`
  font-size: ${fontSize.medium};
  font-weight: normal;
  margin: ${spacingDefaults.normal};
`;

export const StyledHr = Styled.hr`
  border: solid 1px ${color.GRAY};
  margin: 0;
`;
